import { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ActionDialog from '../../../../components/shared/Dialog/ActionDialog';
import { useLikeCafeMutation, useUnlikeCafeMutation } from '../../../../store/api/cafeApi';
import { toast } from 'react-toastify';

const ViewsButton = styled(Button)(() => ({
  margin: 0,
  padding: 0,
  display: 'flex',
  color: '#000000',
  fontFamily: 'Poppins',
  fontWeight: '400',
  fontSize: '14px',
  textTransform: 'none',
  '&:disabled': {
    color: '#000000',
  },
}));
const ToastContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
});

const ButtonNumberLabel = styled('span')(() => ({
  marginLeft: '5px',
  fontWeight: '600',
}));

const ButtonLabel = styled('span')(() => ({
  fontFamily: 'Raleway',
  marginLeft: '3px',
  fontWeight: '400',
}));

export default function LikeAction({ cafeData, currentId, isLogin }) {
  const cafeName = cafeData.cafeName;
  const iscurrentUserLike = cafeData.likedUsers.includes(currentId);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  const [likeCafe] = useLikeCafeMutation();
  const [unlikeCafe] = useUnlikeCafeMutation();
  const isBlock = !currentId || !isLogin;
  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  const handleClickLike = async () => {
    const cafeId = cafeData._id;
    // const userObj = { userId: userDemoId };

    if (iscurrentUserLike) {
      await unlikeCafe({ cafeId, userId: currentId });
      setOpen(false);
    } else {
      await likeCafe({ cafeId, userId: currentId });
      setOpen(false);
    }
  };
  const handleClickCancel = () => {
    setOpen(false);
  };

  return (
    <Box>
      <ToastContainer onClick={clickToast}>
        <ViewsButton
          onClick={iscurrentUserLike && isLogin ? handleOpen : handleClickLike}
          disabled={isBlock}
        >
          {iscurrentUserLike && isLogin ? (
            <ThumbUpAltIcon style={{ color: '#AB9178' }} />
          ) : (
            <ThumbUpOffAltIcon style={{ color: '#AB9178' }} />
          )}
          <ButtonNumberLabel>{cafeData.likedUsers.length}</ButtonNumberLabel>
          <ButtonLabel>likes</ButtonLabel>
        </ViewsButton>
      </ToastContainer>
      <ActionDialog
        img={cafeData.attachments}
        name={cafeName}
        onClose={handleClose}
        open={open}
        variant="cafe"
        action="unlike"
        actionHandler={handleClickLike}
        cancelHandler={handleClickCancel}
      />
    </Box>
  );
}
